import React, { Component } from "react";

import {
  Wrapper,
  Row,
  Card,
  Copy,
  Bold,
  Button,
  Icon
} from "app/NativeComponents/common";
import PhoneNumberItem from "./PhoneNumberItem";
import { checkIfUserHasModule } from "app/NativeActions";
class PhoneNumbers extends Component {
  constructor(props) {
    super(props);
    const plan_module_info = checkIfUserHasModule({
      plan_modules: props.plan_modules,
      user: props.user,
      slug: "messages"
    });
    this.state = {
      plan_module_info
    };
  }
  render() {
    const {
      colors,
      owner_info,
      selected_owner_tab,
      active_property
    } = this.props;

    if (
      owner_info &&
      owner_info.phone_numbers &&
      selected_owner_tab == "phone_numbers"
    ) {
      return (
        <Wrapper
          style={{
            backgroundColor: colors.background_color,
            paddingBottom: 0
          }}
        >
          {owner_info.phone_numbers.length > 0 ? (
            owner_info.phone_numbers.map((phone_number, i) => {
              return (
                <PhoneNumberItem
                  plan_module_info={this.state.plan_module_info}
                  key={phone_number.phone_number}
                  phone_number={phone_number}
                  {...this.props}
                />
              );
            })
          ) : (
            <Wrapper style={{ padding: 15 }}>
              <Copy style={{ textAlign: "center" }}>
                You have no phone numbers for this lead.
              </Copy>
            </Wrapper>
          )}

          <Row style={{ justifyContent: "flex-end", padding: 10 }}>
            <Button
              onPress={() => {
                this.props.setEditModal({
                  title: "Add Phone Number",
                  description:
                    "Add phone number for " + this.props.owner_info.owner_name,
                  slug: "add-owner-phone-number",
                  type: "add_owner_phone_number",
                  fields: {
                    phone_label: "",
                    phone_number: ""
                  },
                  save_button_text: "Add Phone Number",
                  modalAction: ({ fields }) => {
                    this.props.updateOwnerInfo({
                      token: this.props.token,
                      deal_id: this.props.active_property.deal.id,
                      type: "create_phone_number",
                      phone_label: fields.phone_label,
                      phone_number: fields.phone_number,
                      onSuccess: () => {}
                    });
                  },
                  cancelAction: () => {},
                  fieldsUpdated: fields => {}
                });
                this.props.appRedirect({
                  redirect: "goForward",
                  payload: { add: "add-owner-phone-number" }
                });
              }}
            >
              <Row>
                <Icon icon="add" size={18} color={colors.success_color} />
                <Copy style={{ marginLeft: 3, color: colors.success_color }}>
                  Add Phone Number
                  {owner_info.phone_numbers.length == 0 ? " Manually" : ""}
                </Copy>
              </Row>
            </Button>
          </Row>
        </Wrapper>
      );
    }

    return null;
  }
}

export default PhoneNumbers;
